import PropTypes from 'prop-types';
import {
  isNull,
  isObject,
  isString,
  startsWith,
  isFunction,
  some,
} from 'lodash';

import { SegmentAPI } from 'components/scripts/segment';
import { safeExternalUrl } from 'components/utils/url';
import * as styled from './styles';
import { LINK_SIZES as SIZES } from './constants';

export const SmartLink = function SmartLink(props) {
  const {
    to: toProp,
    protocol,
    target,
    children,
    track,
    onClick,
    ...otherProps
  } = props;

  const to =
    protocol && isString(toProp) ? safeExternalUrl(toProp, protocol) : toProp;

  const isInternal =
    to && (isObject(to) || (!startsWith(to, '//') && startsWith(to, '/')));

  const handleOnClickLink = (event) => {
    if (isFunction(onClick)) onClick(event);

    if (track) {
      SegmentAPI('track', `user navigated to ${track.navigateTo}`, {
        source: track.source,
      });
    }
  };

  const rest = { ...otherProps, onClick: handleOnClickLink };

  if (isInternal && !isNull(to)) {
    return (
      <styled.RouterLink target={target} to={to} {...rest}>
        {children}
      </styled.RouterLink>
    );
  }

  const rel = target === '_blank' ? 'noopener noreferrer' : null;

  if (to && !isNull(to)) {
    const externalPrefixes = ['http://', 'https://', '//', 'mailto:', 'tel:'];
    const href = some(externalPrefixes, (prefix) => startsWith(to, prefix))
      ? to
      : `//${to}`;

    return (
      <styled.Link target={target} rel={rel} href={href} {...rest}>
        {children}
      </styled.Link>
    );
  }

  return (
    <styled.Link
      target={target}
      rel={rel}
      notClickable={!to && !onClick}
      {...rest}
    >
      {children}
    </styled.Link>
  );
};

SmartLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  protocol: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node,
  track: PropTypes.object,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

SmartLink.defaultProps = {
  size: SIZES.normal,
};

export const LINK_SIZES = SIZES;
